import { useTranslation } from "react-i18next";
import PagesContainer from "../../components/UI/PagesContainer";
import CardService from "../../services/card.service";
import { useFetch } from "@4uhub/lib4uhub";
import { useCallback, useEffect, useState } from "react";
import { IMedicCard } from "../../models/medic-card";
import { Stack } from "@mui/material";
import BeneficiaryCard from "../../components/MedicCard/BeneficiaryCard";
import { useNavigate } from "react-router-dom";
import { LoadingBeneficiary } from "../../components/GracePeriodCpt/LoadingBeneficiary/LoadingBeneficiary";
import { usePage } from "../../hooks/usePage";

const TRANSLATION_PATH = "page.gracePeriodCpt.";

const cardService = new CardService();

const GracePeriodCpt = () => {
  const { t } = useTranslation();

  const { pageTitle } = usePage();

  const navigate = useNavigate();

  const { sendRequest, loading } = useFetch(cardService.getAll);

  const [cards, setCards] = useState<IMedicCard[]>([]);

  const loadCards = useCallback(async () => {
    const { data, success } = await sendRequest(undefined);
    if (data && success) {
      setCards(data);
    }
  }, [sendRequest]);

  const viewGracePeriod = useCallback(
    (beneficiaryId: string) => {
      navigate(beneficiaryId);
    },
    [navigate]
  );

  useEffect(() => {
    loadCards();
  }, [loadCards]);

  return (
    <PagesContainer
      title={pageTitle || t(TRANSLATION_PATH + "grace_period_cpt")}
    >
      <Stack paddingBottom={4}>
        <Stack spacing={2}>
          {loading &&
            Array.from({ length: 2 }).map((_, index) => (
              <LoadingBeneficiary key={index} />
            ))}
        </Stack>
        {!loading && (
          <Stack spacing={2}>
            {cards.map((item) => (
              <BeneficiaryCard
                key={item.id}
                card={item}
                showShared={false}
                customAction={{
                  label: t(TRANSLATION_PATH + "view"),
                  action: viewGracePeriod,
                }}
              />
            ))}
          </Stack>
        )}
      </Stack>
    </PagesContainer>
  );
};

export default GracePeriodCpt;
